import { TableContainer } from "../../styles";
import { CampoValor } from "../../types";
import { ExternalLink } from "lucide-react";

interface BlocoPrincipalProps {
    campos: CampoValor[];
    idComentario?: number;
    onVerNoContexto?: () => void;
    esconderTabela?: boolean;
}

export default function BlocoPrincipal({ campos, idComentario, onVerNoContexto, esconderTabela = false }: BlocoPrincipalProps) {
    if (!idComentario && campos.length === 0) {
        return null;
    }

    const handleIconClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (onVerNoContexto) {
            onVerNoContexto();
        }
    };

    return (
        <div className="expanded-section">
            <h4 className="section-title">
                Comentário
                {idComentario && (
                    <span style={{ marginLeft: '8px', color: 'var(--c64748b)', fontWeight: 'normal', display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
                        #{String(idComentario).padStart(4, '0')}
                        {onVerNoContexto && (
                            <button
                                onClick={handleIconClick}
                                type="button"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '24px',
                                    width: '24px',
                                    padding: 0,
                                    border: 'none',
                                    background: 'transparent',
                                    cursor: 'pointer',
                                    borderRadius: '4px',
                                    flexShrink: 0,
                                    transition: 'background-color 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.05)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent';
                                }}
                                onMouseDown={(e) => {
                                    e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
                                }}
                                onMouseUp={(e) => {
                                    e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.05)';
                                }}
                                aria-label="Ver comentário no contexto"
                            >
                                <ExternalLink size={14} color="#64748B" />
                            </button>
                        )}
                    </span>
                )}
            </h4>
            {!esconderTabela && campos.length > 0 && (
                <TableContainer>
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th className="field-col">Campo</th>
                                <th className="value-col">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            {campos.map((campo, i) => (
                                <tr key={i} className={i > 0 ? 'border-top' : ''}>
                                    <td className="field-cell">{campo.campo}</td>
                                    <td className={`value-cell ${campo.valor === '—' ? 'empty-value' : ''}`}>
                                        {campo.valor}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </TableContainer>
            )}
        </div>
    );
}

